import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { GlobalService } from '../../services/global.service';
import { ListActionButtonsComponent } from '../../components/list-action-buttons/list-action-buttons.component';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { ModalComponent } from '../../components/modal/modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AgGridListComponent } from "../../components/ag-grid-list/ag-grid-list.component";
import { ButtonComponent } from "../../components/button/button.component";
import { HeaderComponent } from "../../components/header/header.component";
import { TextInputComponent } from "../../components/text-input/text-input.component";
import { PluralPipe } from '../../pipes/plural.pipe';
import { DistrictService } from '../../services/district.service';
import { SelectInputComponent } from '../../components/select-input/select-input.component';
import { CommonModule } from '@angular/common';
import { DropdownService } from '../../services/dropdown.service';
import { BulkUploadComponent } from '../../components/bulk-upload/bulk-upload.component';
import { SearchInputComponent } from '../../components/search-input/search-input.component';
import { FilterByKeyAndValuePipe } from '../../pipes/filter-by-key-and-value.pipe';
import { ValidationService } from '../../services/validation.service';
import { DropdownUploadButtonComponent } from '../../components/dropdown-upload-button/dropdown-upload-button.component';
@Component({
  selector: 'app-district-list-page',
  imports: [HeaderComponent, ButtonComponent, CommonModule, FilterByKeyAndValuePipe, ConfirmationPopupComponent, ModalComponent, TextInputComponent, ReactiveFormsModule, PluralPipe, SelectInputComponent, AgGridListComponent, BulkUploadComponent, SearchInputComponent,DropdownUploadButtonComponent],
  templateUrl: './district-list-page.component.html',
  styleUrl: './district-list-page.component.css'
})
export class DistrictListPageComponent {
  @ViewChild('confirmation_delete_modal') confirmation_delete_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('confirmation_disabled_modal') confirmation_disabled_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('form_modal') form_modal: ModalComponent | undefined;
  @ViewChild('view_modal') view_modal: ModalComponent | undefined;

  @ViewChild('bulk_modal') bulk_modal: any
  page_name = 'District';
  form: FormGroup;
  params: any = {};
  selected_ids: any = {}
  items: any[] = [];
  isSubmitting = false;
  show_menu = false;

  columns: any = [
    { headerName: 'Sr.No', field: 'SrNo', flex: 1 },
    { field: 'State.country.name', headerName: 'Country', filter: true, flex: 1, },
    { field: 'State.name', headerName: 'State', filter: true, flex: 1, },
    // { field: 'Division.name', headerName: 'Division', filter: true, flex: 1, },
    { field: 'name', headerName: 'District', filter: true, flex: 1, },
    { field: 'code', headerName: 'District Code', filter: true, flex: 1, },
    { field: 'is_active', headerName: 'Status', filter: true, flex: 1, valueGetter: (params: any) => params.data?.is_active, cellRenderer: (params: any) => { return params.value ? 'Enable' : 'Disable'; } },
    { headerName: "Actions", sortable: false, cellRenderer: ListActionButtonsComponent, headerClass: 'custom-header-center', cellRendererParams: { actions: this.actions.bind(this) }, editable: false, pinned: 'right', width: 210, minWidth: 210, maxWidth: 210 }
  ];

  bulk_columns = [
    { column_name: 'Country Name', type: 'link', linked_list: 'country_list', linked_from: 'country', return_as: 'country_id', returning_key: 'id', sample_value: 'India' },
    { column_name: 'State Name', type: 'link', linked_list: 'state_list', return_as: 'state_id', returning_key: 'id', sample_value: 'Maharashtra', parent_column: 'country_id', parent_key: 'country.id' },
    // { column_name: 'Division Name', type: 'link',linked_list: 'division_list',returning_key: 'id', return_as: 'division_id', sample_value: 'Mumbai' },
    { column_name: 'District Name', type: 'text', return_as: 'name', sample_value: 'Mumbai City', is_unique: true, min_length: this.vs.min_length_name, max_length: this.vs.max_length_name, regex: this.vs.location_name_pattern, regex_error: `Please enter a valid ${this.page_name} Name` },
    { column_name: 'Code', type: 'text', return_as: 'code', sample_value: 'Mumbai', min_length: this.vs.min_length_code, max_length: this.vs.max_length_code, regex: this.vs.code_pattern },
    // { column_name: 'Status', type: 'text', return_as: 'is_active', sample_value: true },
  ];

  actions(row: any) {
    let actions: any = []
    actions.push({ text: row.is_active ? 'Disable' : 'Enable', shortcut: 'u', color: 'gray', icon: row.is_active ? 'bx bx-block' : 'bx bx-check-circle', function: this.disable.bind(this), permissions: this.gs.user_role_data?.masters_location_disable })
    actions.push({ text: 'View', shortcut: 'u', color: 'sky', icon: 'bx bx-eye', function: this.open_view_modal.bind(this), permissions: this.gs.user_role_data?.masters_location_view })
    actions.push({ text: 'Update', shortcut: 'u', color: 'sky', icon: 'bx bx-edit', disabled: row.is_active === false, function: this.open_form_modal.bind(this), permissions: this.gs.user_role_data?.masters_location_update })
    actions.push({ text: 'Delete', shortcut: 'd', color: 'red', icon: 'bx bx-trash', function: this.open_delete_modal.bind(this), permissions: this.gs.user_role_data?.masters_location_delete })
    return actions
  }

  constructor(public gs: GlobalService, public route: Router, public fb: FormBuilder, public ds: DistrictService, public ar: ActivatedRoute, public dds: DropdownService, public vs: ValidationService) {
    this.form = this.fb.group({
      country_id: ['', [Validators.required]],
      state_id: ['', [Validators.required]],
      // division_id: ['', [Validators.required]],
      name: ['', [Validators.required, Validators.minLength(this.vs.min_length_name), Validators.maxLength(this.vs.max_length_name), Validators.pattern(this.vs.location_name_pattern)]],
      code: ['', [Validators.required, Validators.minLength(this.vs.min_length_code), Validators.maxLength(this.vs.max_length_code), Validators.pattern(this.vs.code_pattern)]],
      is_active: [true]
    });
  }

  async ngOnInit() {
    await this.dds?.get_dropdown_list(['country', 'state']);
    this.ar.queryParams.subscribe(async params => {
      this.params = { ...params }
      await this.get_list(this.params)
    })
  }

  async get_list(filter?: any) {
    try {
      const res = await this.ds.get_list(filter);
      const page = filter?.page || 1;
      const pagesize = filter?.page_size || 10;
      const startindex = (page - 1) * pagesize;

      res.data = res.data.map((item: any, index: number) => ({
        ...item,
        SrNo: startindex + index + 1
      }));

      this.items = res;
    } catch (error: any) {
      console.error("Error fetching Booking list:", error);
    }
  }

  async open_delete_modal(item: any, index: any) {
    this.selected_ids = item;
    this.confirmation_delete_modal?.open();
  }

  async disable(item: any, index: any) {
    this.selected_ids = item;
    this.confirmation_disabled_modal?.open();
  }

  open_view_modal(item: any) {
    console.log(item);
    this.selected_ids = item || {};
    this.view_modal?.open();
  }

  async delete() {
    try {
      let res = await this.ds.delete(this.selected_ids.id);
      if (res != undefined) {
        this.gs.toastr_shows_function(res?.message, 'Success', 'success');
      }
      this.selected_ids = {};
      this.confirmation_delete_modal?.close()
      this.dds.invalidate_dropdown_cache('district');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error.error.message, 'Error', 'error');
    }
  }


  async update_country(item: any) {
    try {
      let form_value = this.form.value;
      let data = item == true ? form_value.is_active == false : form_value.is_active == true
      let update = await this.ds.update(this.selected_ids.id, { is_active: data });
      this.gs.toastr_shows_function('Status has been successfully updated', 'Success', 'success');
      this.confirmation_delete_modal?.close()
      this.dds.invalidate_dropdown_cache('district');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }

  async bulk_delete(ids: any[]) {
    try {
      let res: any
      for (let id of ids) {
        res = await this.ds.delete(id);
      }
      this.gs.toastr_shows_function(res?.message, 'Success', 'success');
      this.dds.invalidate_dropdown_cache('district');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }

  async open_form_modal(item?: any) {
    this.selected_ids = item || {};
    this.form.reset();
    if (this.selected_ids && this.selected_ids.id) {
      let response = await this.ds.get(item.id);
      this.selected_ids = this.gs.addHierarchyIds({ ...response.data });
      this.form.patchValue({ ...this.selected_ids, });
    } else {
      this.selected_ids = {};
      this.form.reset();
    }
    this.form_modal?.open();
  }

  close_form_modal(): void {
    this.form_modal?.close();
  }

  async submit() {
    try {
      if (this.isSubmitting) {
        return;
      }
      if (this.form.invalid) {
        this.gs.toastr_shows_function('Please fill all required fields correctly.', 'Error', 'error');
        this.form.markAllAsTouched();
        return;
      }
      this.isSubmitting = true;
      let form_value = this.form.value;
      delete form_value.country_id
      form_value.is_active = true;
      if (this.selected_ids && this.selected_ids.id) {
        let update_response = await this.ds.update(this.selected_ids.id, form_value);
        this.gs.toastr_shows_function('Changes updated successfully', 'Success', 'success');
      } else {
        let create_response = await this.ds.add(form_value);
        this.gs.toastr_shows_function(create_response?.message, 'Success', 'success');
      }
      this.dds.invalidate_dropdown_cache('district');
      await this.get_list(this.params);
      this.close_form_modal();
    } catch (error: any) {
      this.gs.toastr_shows_function(error.error.message, 'Error', 'error');
    } finally {
      this.isSubmitting = false;
    }
  }

  async bulk_upload(data: any, spinner: any) {
    try {
      const updatedData = data.map((item: any) => ({
        ...item,
        is_active: true
      }));
      await this.gs.bulk_form_submission(updatedData, this.ds, this.params, this.get_list.bind(this), this.bulk_modal, spinner)
    } catch (error: any) {
      this.gs.toastr_shows_function(error.error.message, 'Error', 'error');

    }
  }

  dropdownRegistry: { [depended: number]: any } = {};

  registerDropdown(event: { depended: number; ref: any }) {
    this.dropdownRegistry[event.depended] = event.ref;
  }

  onDropdownChange(event: { value: any, depended: number }) {
    console.log("Dropdown changed:", event);

    const current = event.depended;
    for (const key of Object.keys(this.dropdownRegistry).map(Number)) {
      if (key > current) {
        this.dropdownRegistry[key]?.reset();
      }
    }
  }
}
